//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Post } from '@/models'

export default {
  props: {
    userId: {
      type: String,
      default: ""
    }
  },

  data () {
    return {
      userChannelCount: null
    }
  },

  created () {
    this.getUserKindPostLikeCount()
  },

  methods: {
    getUserKindPostLikeCount () {
      if (!this.loadedLikeList) {
        this.loadedLikeList = true

        Post.getUserChannelCount(this.userId).then(userChannelCount => {
          this.userChannelCount = userChannelCount.filter(like => like.count > 0)
        }).catch(err => {
          this.loadedLikeList = false
          console.error(err)
        })
      }
    },

    goToUserChannelPost (channelCount) {
      // console.log(channelCount)
      this.$router.push({
        name: 'userPosts',
        params: {
          userId: this.userId,
          channelId: channelCount.id
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/user-msg/UserMsgChannelCount.vue